/**
 * @file Unauthorized.jsx
 * @description Displays unauthorized access message and redirect options
 *
 * @section Responsibilities
 * - Show unauthorized access message
 * - Provide navigation options
 * - Handle redirect actions
 * - Display error details
 * - Manage session state
 * - Handle retry attempts
 *
 * @section Dependencies
 * - AuthService: Authentication status
 * - NavigationService: Route handling
 * - SessionService: Session management
 * - ErrorService: Error handling
 *
 * @section Integration Points
 * - Auth System: Authentication status
 * - Navigation System: Route management
 * - Session System: Session state
 * - Error System: Error details
 *
 * @section State Management
 * - authState: Authentication status
 * - redirectState: Navigation state
 * - errorState: Error details
 * - sessionState: Session status
 *
 * @section Events
 * - onRedirect: Navigation handling
 * - onRetry: Retry attempt
 * - onLogout: Session termination
 * - onError: Error handling
 *
 * @section Props
 * @prop {String} errorMessage - Custom error message
 * @prop {String} redirectPath - Default redirect path
 * @prop {Boolean} showRetry - Controls retry button visibility
 * @prop {Function} onRedirect - Custom redirect handler
 */

import React from "react";
import PropTypes from "prop-types";
import SkinPage from "../Platform/SkinPage";

const Unauthorized = (props) => {
  return (
    <SkinPage>
      <div>NOT AUTHORIZED TO SEE THIS PAGE</div>
    </SkinPage>
  );
};

Unauthorized.propTypes = {};

export default Unauthorized;
